import React, { Fragment } from 'react';
import MonthlySalesTrendReportView from './MonthlySalesTrendReportView';

// Thin route entry — the V3 shell lives inside the view.
const MonthlySalesTrendReport = () => (
    <Fragment>
        <MonthlySalesTrendReportView />
    </Fragment>
);

export default MonthlySalesTrendReport;
